/* MyBoost Landing Pages — Tracking
   Emits dataLayer events for GA4 / Meta CAPI consumption.
   Page metadata is read from data-mblp-* attributes on <body> or .mblp-page wrapper.
*/
(function() {
  'use strict';
  window.dataLayer = window.dataLayer || [];

  function readPageMeta() {
    var el = document.querySelector('[data-mblp-page-id]') || document.body;
    return {
      mblp_page_id: el.getAttribute('data-mblp-page-id') || 'unknown',
      mblp_persona: el.getAttribute('data-mblp-persona') || 'unknown',
      mblp_style: el.getAttribute('data-mblp-style') || 'unknown',
      mblp_angle: el.getAttribute('data-mblp-angle') || 'unknown',
      mblp_format: el.getAttribute('data-mblp-format') || 'unknown'
    };
  }

  function emit(eventName, extra) {
    var payload = Object.assign({ event: eventName }, readPageMeta(), extra || {});
    window.dataLayer.push(payload);
  }

  // Public API
  window.mblpTrack = emit;

  // Auto: page_view on DOM ready
  function onReady() {
    emit('mblp_page_view', { page_url: window.location.href, page_title: document.title });
    setupScrollDepth();
    setupCTAClicks();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Auto: scroll depth at 25/50/75/100 (throttled via rAF to avoid jank on mobile)
  function setupScrollDepth() {
    var fired = { 25: false, 50: false, 75: false, 100: false };
    var thresholds = [25, 50, 75, 100];
    var ticking = false;
    function compute() {
      var doc = document.documentElement;
      var scrolled = (window.scrollY + window.innerHeight) / doc.scrollHeight * 100;
      thresholds.forEach(function(t) {
        if (!fired[t] && scrolled >= t) {
          fired[t] = true;
          emit('mblp_scroll_depth', { depth_pct: t });
        }
      });
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(compute);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    compute();
  }

  // Auto: clicks on [data-mblp-cta]
  function setupCTAClicks() {
    document.addEventListener('click', function(e) {
      var cta = e.target.closest('[data-mblp-cta]');
      if (!cta) return;
      emit('mblp_cta_click', {
        cta_id: cta.getAttribute('data-mblp-cta'),
        cta_label: (cta.textContent || '').trim().slice(0, 60),
        cta_section: (cta.closest('[data-mblp-section]') || {}).getAttribute && cta.closest('[data-mblp-section]').getAttribute('data-mblp-section') || 'unknown'
      });
    });
  }

  // Auto: reveal-on-scroll for .mblp-reveal
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mblp-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    function observeReveal() {
      document.querySelectorAll('.mblp-reveal:not(.mblp-revealed)').forEach(function(el) { observer.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeReveal);
    } else {
      observeReveal();
    }
  } else {
    // No IO support: just reveal all
    document.documentElement.classList.add('mblp-no-io');
    var addClass = function() {
      document.querySelectorAll('.mblp-reveal').forEach(function(el) { el.classList.add('mblp-revealed'); });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addClass);
    } else {
      addClass();
    }
  }
})();
